import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSmsLogs = lazy(() => import("@/pages/admin/AdminSmsLogs"));

export const Route = createFileRoute("/admin/sms-logs")({
  component: AdminSmsLogs,
});
